import { useFormik } from "formik";
import React, { useState } from "react";
import { MyCheckbox } from "../../../../components/MyCheckbox";
import InfoTooltip from "components/InfoTooltip";
const ReversalCheckBoxes = ({ edit, formik, addNew }) => {
  const [disabled, setDisable] = useState(true);
  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    formik.setFieldValue(name, type === "checkbox" ? checked : value);
  };
  return (
    <div style={{ marginLeft: "47px" }}>
      <div className="d-flex  mt-5 pt-5">
        Applicable to:
        <div className="d-flex">
          <div
            className="m-0 reversal-checks type-check-box pl-5 "
            style={{
              pointerEvents:
                disabled && edit === false && addNew === false
                  ? "none"
                  : "initial",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MyCheckbox
              name={`reversal_applicable_charge`}
              title="Charges"
              handlechange={onChange}
              checked={formik.values?.reversal_applicable_charge}
            />
            <InfoTooltip text="Allows this reversal type to be applied to charge transactions." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
          <div
            className="m-0 reversal-checks type-check-box pl-5 "
            style={{
              pointerEvents:
                disabled && edit === false && addNew === false
                  ? "none"
                  : "initial",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MyCheckbox
              name={`reversal_applicable_payment`}
              title="Payments"
              handlechange={onChange}
              checked={formik.values?.reversal_applicable_payment}
            />
            <InfoTooltip text="Allows this reversal type to be applied to payment transactions." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
          <div
            className="m-0 reversal-checks type-check-box pl-5 "
            style={{
              pointerEvents:
                disabled && edit === false && addNew === false
                  ? "none"
                  : "initial",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MyCheckbox
              name={`reversal_gateway_refund`}
              title="Do not refund through gateway"
              handlechange={onChange}
              checked={formik.values?.reversal_gateway_refund}
            />
            <InfoTooltip text="When checked, reversing a transaction of this type only updates the record here. The payer is not refunded through the payment gateway (for example Stripe or Authorize.net)." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
        </div>
      </div>
      <div
        className="m-0 reversal-checks type-check-box mt-5 pt-5"
        style={{
          pointerEvents:
            disabled && edit === false && addNew === false ? "none" : "initial",
          color: "#ACACAC",
          display: "flex",
          alignItems: "center",
        }}
      >
        <MyCheckbox
          name={`reversal_hidden_statement`}
          title="Hide on Statement"
          handlechange={onChange}
          checked={
            addNew === true ? false : formik.values?.reversal_hidden_statement
          }
        />
        <InfoTooltip text="Excludes reversal entries of this type from the member's printed or emailed statement." style={{ marginLeft: '6px', marginBottom: '8px' }} />
      </div>
    </div>
  );
};

export default ReversalCheckBoxes;
